import React from "react";
import ReviewStars from "./ReviewStars";

export default function ReviewInSet({ review }) {
  return (
    <div className="flex flex-col review-in-set justify-center items-center p-10 cursor-pointer mx-6 sm:mx-auto mb-16 lg:mb-0">
      <div className="mr-1">
        <ReviewStars
          rating={review.Rating}
          starSize="27px"
          starSpacing="10px"
        />
      </div>
      <div className="text-center text-sm mt-4 lg:h-40">
        {review.Title && <p>"{review.Title}"</p>}
        {review.ReviewText && (
          <p title={review.ReviewText}>
            {review.ReviewText.substr(0, 250)}
            {review.ReviewText.length > 250 && "..."}
          </p>
        )}
      </div>
      <div className=" my-2 items-center font-bold">
        <div className="flex flex-col text-center">
          <p className="leading-4">
            {review.UserNickname ? `${review.UserNickname}` : `Anonymous`}
          </p>
          <p className="text-gray-400">
            {new Date(review.SubmissionTime).toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
}
